import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Download, Loader2 } from 'lucide-react';
import { Cover, Page1, Page2, Page3, Page4 } from './components/report/ReportContent';
import { Page5, Page6, Page7, Page8 } from './components/report/ReportContentEnd';
import './components/report/report.css';
import GateLanding from './components/gate/GateLanding';
import AdminDashboard from './components/admin/AdminDashboard';

/* ─── Layer 2: The full report ─── */
const Report = () => {
  return (
    <div className="min-h-screen bg-muted/50 report-container print:bg-white">
      <div className="no-print fixed top-6 right-6 z-50">
        <a
          href="/GDO_Italia_2025-2030_Skillvue.pdf"
          download="GDO_Italia_2025-2030_Skillvue.pdf"
          data-testid="download-pdf-btn"
          className="flex items-center gap-2 rounded-xl gradient-bg px-5 py-3 text-sm font-semibold text-white shadow-lg hover:opacity-90 transition-opacity font-display"
        >
          <Download className="h-4 w-4" />Scarica PDF
        </a>
      </div>
      <div className="mx-auto max-w-[850px] bg-card shadow-xl print:shadow-none print:max-w-none">
        <Cover />
        <Page1 />
        <Page2 />
        <Page3 />
        <Page4 />
        <Page5 />
        <Page6 />
        <Page7 />
        <Page8 />
      </div>
    </div>
  );
};

/* ─── App: Gate logic ─── */
function App() {
  const [unlocked, setUnlocked] = useState(() => {
    return sessionStorage.getItem('report_unlocked') === 'true';
  });

  const handleUnlock = () => {
    sessionStorage.setItem('report_unlocked', 'true');
    window.scrollTo(0, 0);
    setUnlocked(true);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={unlocked ? <Report /> : <GateLanding onUnlock={handleUnlock} />}
          />
          <Route path="/report" element={unlocked ? <Report /> : <GateLanding onUnlock={handleUnlock} />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
